var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreVerticalFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 3.0011C8 1.89664 8.89502 1.0015 10.0015 1.0015C11.106 1.0015 12.001 1.89664 12.001 3.0011C12.001 4.10559 11.106 5.00073 10.0015 5.00073C8.89501 5.00073 8 4.10559 8 3.0011Z",
    fill: "black",
    stroke: "black",
    strokeOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19.0011C8 17.8966 8.89502 17.0015 10.0015 17.0015C11.106 17.0015 12.001 17.8966 12.001 19.0011C12.001 20.1056 11.106 21.0007 10.0015 21.0007C8.89501 21.0007 8 20.1056 8 19.0011Z",
    fill: "black",
    stroke: "black",
    strokeOpacity: 0.01
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.0011C8 9.89664 8.89502 9.0015 10.0015 9.0015C11.106 9.0015 12.001 9.89664 12.001 11.0011C12.001 12.1056 11.106 13.0007 10.0015 13.0007C8.89501 13.0007 8 12.1056 8 11.0011Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVerticalFilled);
export default __webpack_public_path__ + "static/media/MoreVerticalFilled.c6ed29216a02cf42db1cfbb161c40642.svg";
export { ForwardRef as ReactComponent };